import React from 'react';
export const Toasts = ({
  color = '#0D1137',
  width = '30px',
  height = '30px',
}) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512"  space="preserve" width={width} height={height} class=""><g><g>
	<g>
		<circle cx="119.45" cy="80.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="179.45" cy="120.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="119.45" cy="110.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="119.45" cy="190.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="99.45" cy="220.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="189.45" cy="150.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="279.45" cy="130.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="279.45" cy="80.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="209.45" cy="80.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="240.45" cy="120.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="119.45" cy="270.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<path d="M306.78,47.037C279.313,36.051,242.635,30,203.5,30s-75.813,6.051-103.28,17.037C88.427,51.754,61,64.651,61,82.5    c0,8.609,6.706,17.435,19.391,25.521c2.405,1.533,3.747,4.354,3.419,7.188c-6.016,51.924-12.419,106.752-19.577,167.616    c-1.491,12.679,7.272,24.658,20.384,27.866c8.346,2.042,18.069,4.354,27.856,5.968c4.833,0.797,18.827,2.733,19.42,2.816    c0.349,0.048,0.695,0.071,1.037,0.071c3.686,0,6.9-2.719,7.42-6.474c0.568-4.101-2.298-7.887-6.401-8.456    c-0.144-0.02-14.394-1.992-19.037-2.758c-9.264-1.526-18.655-3.762-26.731-5.737c-5.768-1.411-9.659-6.374-9.051-11.544    c7.158-60.873,13.563-115.709,19.58-167.642c0.984-8.498-3.041-16.962-10.255-21.563C78.237,88.859,76,83.872,76,82.5    c0-3.014,7.501-12.62,29.791-21.535C131.527,50.67,166.228,45,203.5,45c37.272,0,71.973,5.67,97.71,15.965    C323.499,69.88,331,79.486,331,82.5c0,1.372-2.237,6.359-12.457,12.874c-7.214,4.601-11.239,13.064-10.253,21.561l2.52,21.731    c0.479,4.114,4.207,7.069,8.315,6.585c4.114-0.478,7.063-4.2,6.585-8.315l-2.52-21.728c-0.329-2.832,1.013-5.653,3.417-7.187    C339.294,99.935,346,91.109,346,82.5C346,64.651,318.572,51.754,306.78,47.037z" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<path d="M459.482,281.67C477.163,266.357,481,250.451,481,239.542c0-25.85-20.626-48.337-58.078-63.317    c-18.493-7.397-40.46-12.805-64.297-15.959c-1.403-12.049-2.784-23.926-4.143-35.638C372.163,109.315,376,93.409,376,82.5    c0-25.85-20.626-48.337-58.078-63.317C286.997,6.813,246.361,0,203.5,0c-42.861,0-83.497,6.813-114.422,19.183    C51.626,34.163,31,56.65,31,82.5c0,10.91,3.837,26.815,21.517,42.128c-5.615,48.4-11.535,99.053-18.079,154.693    c-3.257,27.697,15.251,53.711,43.05,60.511c10.962,2.682,22.169,5.04,33.308,7.011c12.686,2.244,25.605,4.035,38.509,5.354    c-3.147,26.941-6.42,54.857-9.867,84.167c-3.257,27.697,15.251,53.711,43.05,60.511C223.516,506.911,265.903,512,308.476,512    c0.008,0,0.017,0,0.024,0c42.59-0.001,84.985-5.09,126.011-15.126c27.799-6.799,46.307-32.813,43.051-60.511    C471.072,381.187,465.152,330.533,459.482,281.67z M113.41,332.071c-10.822-1.913-21.708-4.204-32.357-6.81    c-20.456-5.003-34.091-24-31.717-44.188c6.727-57.202,12.795-109.135,18.551-158.768c0.3-2.589-0.765-5.148-2.813-6.759    C52.596,105.731,46,94.304,46,82.5c0-19.301,17.277-36.842,48.649-49.39C123.844,21.432,162.502,15,203.5,15    s79.655,6.432,108.852,18.11C343.723,45.658,361,63.199,361,82.5c0,11.804-6.596,23.231-19.074,33.047    c-2.049,1.611-3.113,4.17-2.813,6.759c1.383,11.921,2.787,24.005,4.215,36.27c-11.335-1.012-22.996-1.534-34.827-1.534    c-42.861,0-83.497,6.813-114.422,19.183c-6.927,2.771-13.273,5.799-19.025,9.057c1.179-1.325,1.901-3.065,1.901-4.978    c0-4.142-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5c0.571,0,1.126-0.069,1.66-0.19    C148.294,201.652,136,219.594,136,239.542c0,10.91,3.837,26.815,21.517,42.128c-2.109,18.176-4.26,36.67-6.472,55.626    C138.434,336.013,125.807,334.265,113.41,332.071z M430.946,482.304C391.087,492.055,349.89,496.999,308.5,497    c-0.011,0-0.015,0-0.024,0c-41.37,0-82.563-4.945-122.423-14.696c-20.456-5.003-34.091-24-31.717-44.188    c6.727-57.202,12.795-109.135,18.551-158.768l0.483-4.166l-3.296-2.593C157.596,262.773,151,251.346,151,239.542    c0-19.301,17.277-36.842,48.649-49.39c29.195-11.679,67.853-18.11,108.851-18.11c13.629,0,26.988,0.726,39.838,2.104    c1.315,0.719,2.854,1.055,4.455,0.866c0.39-0.045,0.766-0.129,1.134-0.23c23.64,2.927,45.348,8.141,63.425,15.371    C448.723,202.7,466,220.241,466,239.542c0,11.804-6.596,23.231-19.074,33.047l-3.297,2.593l0.483,4.166    c5.813,50.124,11.882,102.057,18.553,158.768C465.038,458.304,451.402,477.301,430.946,482.304z" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<path d="M428.19,272.25c-0.329-2.832,1.013-5.653,3.417-7.187C444.294,256.977,451,248.151,451,239.542    c0-17.849-27.428-30.746-39.22-35.463c-27.467-10.986-64.146-17.037-103.28-17.037c-39.134,0-75.813,6.051-103.28,17.037    c-11.792,4.717-39.22,17.614-39.22,35.463c0,4.143,3.358,7.5,7.5,7.5c4.142,0,7.5-3.357,7.5-7.5    c0-3.014,7.501-12.62,29.791-21.535c25.737-10.295,60.438-15.965,97.709-15.965s71.973,5.67,97.71,15.965    c22.289,8.915,29.79,18.521,29.79,21.535c0,1.372-2.237,6.359-12.457,12.874c-7.214,4.601-11.239,13.064-10.253,21.562    c6.017,51.934,12.421,106.77,19.579,167.641c0.608,5.171-3.283,10.134-9.052,11.545c-37.727,9.229-76.517,13.843-115.32,13.841    c-38.794-0.001-77.601-4.614-115.315-13.841c-5.768-1.411-9.659-6.374-9.051-11.544c0.484-4.113-2.459-7.841-6.573-8.324    c-4.112-0.483-7.841,2.458-8.325,6.572c-1.491,12.679,7.272,24.658,20.384,27.866c38.885,9.513,78.882,14.27,118.88,14.27    s79.996-4.757,118.885-14.27c13.111-3.207,21.875-15.187,20.385-27.866C440.609,379.004,434.206,324.177,428.19,272.25z" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="229.45" cy="240.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="289.45" cy="280.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="229.45" cy="270.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="229.45" cy="350.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="279.45" cy="340.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="259.45" cy="380.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="209.45" cy="380.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="299.45" cy="310.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="389.45" cy="290.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="389.45" cy="380.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="349.45" cy="410.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="389.45" cy="420.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="389.45" cy="240.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="419.45" cy="400.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="339.45" cy="450.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g><g>
	<g>
		<circle cx="229.45" cy="430.3" r="7.5" data-original="#000000" class="active-path" data-old_color="#000000" fill={color}/>
	</g>
</g></g> </svg>
 );
};
